import Vue from "vue";
import Vuetify from "vuetify/lib";
import { UserVuetifyPreset } from "vuetify";
import pt from "vuetify/src/locale/pt";
import Icon from "@/components/icons/Icon.vue";
import iconeDish from "@/assets/icones/dish.png";
import iconeConversation from "@/assets/icones/conversation.png";
import iconeHand from "@/assets/icones/hand.png";
import iconeMoney from "@/assets/icones/money.png";
import iconeTeacher from "@/assets/icones/teacher.png";
import iconeValue from "@/assets/icones/value.png";
import iconeChessKing from "@/assets/icones/chess-king.png";

Vue.use(Vuetify);

export const opcoesDoVuetify: Partial<UserVuetifyPreset> = {
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#046091",
        secondary: "#003f62",
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "mdi",
    values: {
      dish: {
        component: Icon,
        props: { icon: iconeDish },
      },
      conversation: {
        component: Icon,
        props: { icon: iconeConversation },
      },
      hand: {
        component: Icon,
        props: { icon: iconeHand },
      },
      money: {
        component: Icon,
        props: { icon: iconeMoney },
      },
      teacher: {
        component: Icon,
        props: { icon: iconeTeacher },
      },
      value: {
        component: Icon,
        props: { icon: iconeValue },
      },
      chess_king: {
        component: Icon,
        props: { icon: iconeChessKing },
      },
    },
  },
};

export default new Vuetify(opcoesDoVuetify);
